import { FormattedMessage } from 'react-intl';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BrandXL } from '@sorare/core/src/atoms/typography';
import { FrameCorners } from '@sorare/core/src/atoms/ui/FrameCorners';
import { MaskIcon } from '@sorare/core/src/atoms/ui/MaskIcon';

import flameUrl from './assets/flame.svg';

export const HotStreakTitle = () => {
  return (
    <div className="relative px-2 py-1">
      <FrameCorners cornerSize={8} color="var(--c-black)" />
      <Horizontal center gap={0.5}>
        <MaskIcon url={flameUrl} size={3} color="var(--c-black)" />
        <BrandXL color="var(--c-black)">
          <FormattedMessage defaultMessage="Hot Streaks" />
        </BrandXL>
      </Horizontal>
    </div>
  );
};
